import React, { useState } from 'react'
import { Button, Popover, Spin } from 'antd'
import { FileDown } from 'lucide-react'
import { ExportOptions } from './ExportOptions'
import { useFFEStore } from '../../store/ffeStore'
import { useApi } from '../../services/ApiContext'
import { useCompanyStore } from '../../store/company/companyStore'
import FileSaver from 'file-saver'

export const ExportButton: React.FC = () => {
  const [open, setOpen] = useState(false)
  const api = useApi()
  const [loading, setLoading] = useState(false)

  const handleExport = async () => {
    // Close popover

    // Trigger print mode
    // set the document title
    setLoading(true)
    try {
      const document = useFFEStore.getState().document
      const suppliers = useFFEStore.getState().suppliers
      const company = useCompanyStore.getState().company
      const response = (await api.downloadPDF(
        company,
        document,
        suppliers,
        'document'
      )) as Blob
      FileSaver.saveAs(
        response,
        `${(document.projectTitle === '' ? 'Project' : document.projectTitle) + '-FFE' + '-' + new Date().toLocaleDateString()}.pdf`
      )
      setOpen(false)
    } catch (error) {
      console.error('Error exporting PDF', error)
    }
    setLoading(false)
  }

  return (
    <Popover
      content={
        loading ? (
          <Spin spinning tip="Exporting PDF...">
            <div className="h-40 w-40"></div>
          </Spin>
        ) : (
          <ExportOptions onExport={handleExport} />
        )
      }
      title={!loading && 'Export Options'}
      trigger="click"
      open={open}
      onOpenChange={setOpen}
    >
      <Button type="primary" icon={<FileDown className="h-4 w-4" />}>
        Export PDF
      </Button>
    </Popover>
  )
}
